import React , {useEffect , useState} from 'react';
import classes from './../Onboarding.module.scss';
import loading_image from './../../../assets/onboarding/loading_image.svg'
import UpperDiv from './UpperDiv';
import LowerDiv from './LowerDiv';
import Pagination from './Pagination';
import { useNavigate } from 'react-router-dom';

const upperDivStyle = {
  display: "flex",
  alignItems: 'flex-end',
  justifyContent: 'center'
}

const lowerrDivStyle = {
  display: "flex",
  flexDirection: 'column',
  gap:'0'
}



const Page1 = () => {
  const [isPhoto , setIsPhoto] = useState()

  const navigate = useNavigate();
  const data = JSON.parse(localStorage.getItem('data'));

  useEffect(() => {
    if (data) {
      if (data.photo === null || data.photo.toString().trim().length < 100 ) {
        setIsPhoto(true);
        return;
      } else {
        setIsPhoto(false);
      }
    }
  }, [])

  return (
    <>
      <UpperDiv style={upperDivStyle}>
        <img src={loading_image} alt="" style={{maxWidth:"80%"}}/>
      </UpperDiv>
      <LowerDiv style={lowerrDivStyle}>
        <div className={classes.Page1Div}>
          <h3 className={classes.IntroH3}>
            Welcome to
          </h3>
          <h3 className={classes.NameH3}>
            GATI APP
          </h3>
          
        </div>
        <div className={classes.Page1Pagination}>
        <div style={{ display: 'flex' , width:"100%"}}>
            {/* <button onClick={() => { navigate('/dashboard/home') }}>
              GO BACK
            </button> */}
            <button onClick={() => { navigate('/onboarding/2') }}>
              NEXT
            </button>
          </div>
          <Pagination numberOfDots={7} activePage={1}/>
        </div>
      </LowerDiv>
    </>
  )
}

export default Page1